import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { isMessageDescriptor } from '../helpers';

interface ILabelProps {
    message?: MessageDescriptor | string;
    required?: boolean;
    field: string;
    className?: string
}

const Label: React.FunctionComponent<ILabelProps> = ({ message, required, field, className }) => (
    message ?
        <label className={className || ''} htmlFor={field}>
            {isMessageDescriptor(message)
                ? <FormattedMessage {...message} />
                : message
            }
            {required && <span className="question__required"> *</span>}
        </label>
        : <></>
);

export default Label;